import {addEvent} from '../add-event'

export function clickIndividualVesselEvent(
    checked: boolean,
    numberOfOtherVesselsSelected: number,
): boolean {
    return addEvent('reportsPageClickIndividualVessel', {
        newState: checked ? 'Selected' : 'Not selected',
        numberOfOtherVesselsSelected,
    })
}
